import React from "react";
import { Box, Typography } from "@mui/material";
import { colors } from "../../theme";
import { AUTH_PROMO_COPY } from "./authHelpers";
import {
  BRAND_ASSETS,
  BRAND_COLORS,
  brandFullLogoImgSx,
  brandRgba,
} from "../../utils/brandAssets";

const AuthBrandPanel = ({ mode }) => {
  const copy = AUTH_PROMO_COPY[mode];

  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        overflow: "hidden",
        bgcolor: "#0f0f0f",
        px: { md: 5 },
        py: { md: 5 },
        minHeight: "100%",
        height: "100%",
      }}
    >
      <Box
        aria-hidden
        sx={{
          pointerEvents: "none",
          position: "absolute",
          inset: 0,
          opacity: 0.7,
          background: `
            radial-gradient(ellipse 80% 60% at 20% 100%, ${brandRgba(BRAND_COLORS.cyan, 0.15)}, transparent 55%),
            radial-gradient(ellipse 50% 40% at 80% 0%, ${brandRgba(BRAND_COLORS.cyan, 0.08)}, transparent 50%)
          `,
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Box
            component="img"
            src={BRAND_ASSETS.fullLogo}
            alt="Stats.fan Logo"
            sx={brandFullLogoImgSx}
          />
        </Box>

        <Box sx={{ position: "relative", zIndex: 1 }}>
          <Typography
            variant="h5"
            component="h2"
            sx={{
              fontWeight: 700,
              letterSpacing: "-0.02em",
              color: colors.textPrimary,
              mb: 1,
            }}
          >
            {copy.title}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              lineHeight: 1.7,
              color: colors.textSecondary,
            }}
          >
            {copy.subtitle}
          </Typography>
        </Box>
      </Box>

      <Typography
        variant="caption"
        sx={{
          position: "relative",
          zIndex: 1,
          color: colors.textSecondary,
          mt: 3,
        }}
      >
        Compare · Debate · Discover
      </Typography>
    </Box>
  );
};

export default AuthBrandPanel;
